import Spinner from "Components/atoms/icons/spinner";
import LoadingState from "Components/organisms/loading-state";
import React from "react";
import { Container, Breadcrumb } from "reactstrap";
import { CheckCircleIcon, PackageIcon, ChartIcon } from "Components/atoms/icons";


interface SystemDashboardTemplateProps {
    handleClick: () => any
    isLoadingData: boolean,
    userCount: number | null,
    lastSync: string | null
}

const SystemDashboardTemplate = ({
    handleClick,
    isLoadingData,
    userCount,
    lastSync
}: SystemDashboardTemplateProps) => {

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumb title="IbexIQ Dashboard" breadcrumbItem="Dashboard" />
                    <div className="text-center mb-5">
                        <h1 className="fw-bold text-primary">Welcome to IbexIQ</h1>
                        <p className="text-muted">Your intelligent hub for operational insights and system integration.</p>
                    </div>

                    <div className="row g-4 mb-5">
                        <div className="col-md-3">
                            <div className="card shadow-sm border-0">
                                <div className="card-body text-center">
                                    <h5 className="card-title text-secondary">Connected Systems</h5>
                                    {
                                        isLoadingData ? <LoadingState /> : <h2 className="fw-bold text-primary">2</h2>
                                    }
                                    <p className="small text-muted">Acumatica, Dayforce</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="card shadow-sm border-0">
                                <div className="card-body text-center">
                                    <h5 className="card-title text-secondary">Last Sync</h5>
                                    {
                                        isLoadingData ? <LoadingState /> : <h2 className="fw-bold text-success">{lastSync}</h2>
                                    }
                                    <p className="small text-muted">All systems up-to-date</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="card shadow-sm border-0">
                                <div className="card-body text-center">
                                    <h5 className="card-title text-secondary">Active Users</h5>
                                    {
                                        isLoadingData ? <LoadingState /> : <h2 className="fw-bold">{userCount}</h2>
                                    }

                                    <p className="small text-muted">Across departments</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="card shadow-sm border-0">
                                <div className="card-body text-center">
                                    <h5 className="card-title text-secondary">Reports Generated</h5>
                                                                {
                                        isLoadingData ? <LoadingState /> : <h2 className="fw-bold text-primary">--</h2>
                                    }
                                    <p className="small text-muted">This month</p>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="card shadow-sm border-0 mb-4">
                        <div className="card-body">
                            <h5 className="card-title">About IbexIQ</h5>
                            <p className="card-text text-muted">
                                IbexIQ connects your core business systems into one intelligent backbone — aligning Finance, HR, and Project data
                                to give you real-time operational insights and reduce manual effort.
                            </p>
                        </div>
                    </div>


                    <div className="card shadow-sm border-0 mb-4">
                        <div className="card-body">
                            <h5 className="card-title">Recent Activity</h5>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item"><CheckCircleIcon className="text-success" /> Dayforce Payroll sync completed successfully.</li>
                                <li className="list-group-item"><PackageIcon className="text-warning" /> 3 new invoices imported from Acumatica.</li>
                                <li className="list-group-item"><ChartIcon className="text-info" /> Job Cost variance report generated.</li>
                            </ul>
                        </div>
                    </div>


                    <div className="text-center">
                        <a href="#" onClick={handleClick} className="btn btn-primary m-2">View Reports</a>
                        <a href="#" onClick={handleClick} className="btn btn-outline-primary m-2">Manage Integrations</a>
                        <a href="#" onClick={handleClick} className="btn btn-outline-secondary m-2">System Settings</a>
                    </div>


                    {/* <div className="text-center text-muted mt-5"> */}
                        {/* <small>© 2025 IbexIQ | Version 1.0.0 | Support: support@ibexiq.com</small> */}
                    {/* </div> */}
                </Container>
            </div >
        </React.Fragment >
    );
}

export default SystemDashboardTemplate;